import { Controller } from "@hotwired/stimulus";
import $ from 'jquery';

export default class extends Controller {
  static targets = ["breedSelect"];
  static values = {
    url: String
  };

  async change(event) {
    const livestockType = event.target.value;
    if (!livestockType) return;

    const url = `${this.urlValue}?livestock_type=${encodeURIComponent(livestockType)}`;
    const response = await fetch(url);
    const breeds = await response.json();
    
    this.updateOptions(breeds);
  }

  updateOptions(breeds) {
    const $select = $(this.breedSelectTarget);
    const currentValue = $select.val();
    
    const options = breeds.map(breed => ({ id: breed.name, text: breed.name }));
    $select.empty().select2({ data: options });
    
    if (breeds.some(b => b.name === currentValue)) {
      $select.val(currentValue).trigger('change');
    }
  }
}

